import { useMutation, useQueryClient } from '@tanstack/react-query';

import { Groups } from '@app/client';
import { type UpdateInviteParam } from '@app/client/common/structs/groups/groups';

import { PODS_SIDEBAR_FOLLOWING_CACHE_KEY } from './useGetGroups';
import { groupsCacheKeys } from './utils';

interface UseAcceptGroupInviteParams {
    onSuccess?: (_data, variables) => void;
    onError?: (_data, variables) => void;
}

/**
 * React Hook using React Query useMutation to
 * delete a Member from a Pod.
 */
export function useAcceptGroupInvite(options?: UseAcceptGroupInviteParams) {
    const queryClient = useQueryClient();

    return useMutation(({ groupId, inviteId }: UpdateInviteParam) => Groups.callAcceptInvite({ groupId, inviteId }), {
        onSuccess: (_data, variables) => {
            if (options?.onSuccess) options.onSuccess(_data, variables);
            queryClient.invalidateQueries(PODS_SIDEBAR_FOLLOWING_CACHE_KEY);
            queryClient.invalidateQueries(groupsCacheKeys.invites(variables.groupId));
            queryClient.invalidateQueries(groupsCacheKeys.group(variables.groupId));
            queryClient.invalidateQueries(groupsCacheKeys.collections(variables.groupId));
            queryClient.invalidateQueries(groupsCacheKeys.items(variables.groupId));
        },
        onError: (_error: Error, variables) => {
            if (options?.onError) options.onError(_error, variables);
            queryClient.invalidateQueries(groupsCacheKeys.invites(variables.groupId));
        },
    });
}
